"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Circle = exports.SpinnerStyled = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

var rotator = (0, _styledComponents.keyframes)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(270deg);\n  }\n"])));
var colors = (0, _styledComponents.keyframes)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  0% {\n    stroke: #e83f40;\n  }\n  25% {\n    stroke: #4382E5;\n  }\n  75% {\n    stroke: #C10203;\n  }\n  100% {\n    stroke: #e83f40;\n  }\n"])));
var dash = (0, _styledComponents.keyframes)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  0% {\n    stroke-dashoffset: 187;\n  }\n  50% {\n    stroke-dashoffset: 46.75;\n    transform        : rotate(135deg);\n  }\n  100% {\n    stroke-dashoffset: 187;\n    transform        : rotate(450deg);\n  }\n"])));

var SpinnerStyled = _styledComponents["default"].svg(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  animation: 1.4s ", " ease-out;\n"])), rotator);

exports.SpinnerStyled = SpinnerStyled;
SpinnerStyled.displayName = 'SpinnerStyled';

var Circle = _styledComponents["default"].circle(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  stroke-dasharray : 187;\n  stroke-dashoffset: 0;\n  transform-origin : center;\n  animation        : ", " 1.4s ease-in-out infinite, ", " 5.6s ease-in-out infinite;\n"])), dash, colors);

exports.Circle = Circle;
Circle.displayName = 'Circle';